import ApiService from "../ApiService";
import { StorageService } from "../StorageService";

const vademecumService = {
    getVademecum(page, rowsPerPage) {
        return ApiService.customRequest({
          //  url: `${ApiService.getVademecumUrl()}/medicine/allpag/?page=${page}&perPage=${rowsPerPage}`,
          url: `${ApiService.getVademecumUrl()}/medicine/`,
            method: 'get'
        });
    },

    updateVademecumItem(data) {
        return ApiService.customRequest({
            url: `${ApiService.getVademecumUrl()}/medicine/`,
            method: 'post',
            data
        });
    },

    getVademecumOrder(data) {
        return ApiService.customRequest({
            url: `${ApiService.getVademecumUrl()}/medicine/`,
            method: 'get',
            data
        });
    },
 
    uploadVademecum(file) {
        const userId = StorageService.getUserData().id;
        const formData = new FormData();
        const headers = { 'Content-Type': 'multipart/form-data' };
        formData.append("file", file);

        return ApiService.customRequest({
            url: `${ApiService.getVademecumUrl()}/upload/load/${userId}`,
            method: 'post',
            headers,
            data: formData
        });
    },

    findIdPlu(id, page, rowsPerPage) {
        return ApiService.customRequest({
            url: `${ApiService.getVademecumUrl()}/medicine/one/?plu=${id}&page=${page}&perPage=${rowsPerPage}`,
            method: 'get'
        })
    },

    findDescripcion(type, bool, page, rowsPerPage) {
        return ApiService.customRequest({
            url: `${ApiService.getVademecumUrl()}/medicine/MedicineCondition/?type=${type}&bool=${bool}&page=${page}&perPage=${rowsPerPage}`,
            method: 'get'
        })
    }
};

export default vademecumService;
